import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-char-counter',
  standalone: true,
  imports: [CommonModule],
  templateUrl: `./char-counter.html`,
  styleUrls: [`./char-counter.scss`]
})
export class CharCounterComponent {
  text = input<string | null>('');
  maxLength = input<number>(500);

  currentLength = computed(() => this.text()?.length ?? 0);
  isNearLimit = computed(() => this.currentLength() >= this.maxLength() * 0.9);
  isAtLimit = computed(() => this.currentLength() >= this.maxLength());
}